import axios from 'axios';

//const baseURL1 = "http://localhost:5001/api"
//const baseURL1 = "https://leads.prepb.com/api"
const baseURL1 = `${window.location.origin}/api`


const api = axios.create({ baseURL: baseURL1, timeout: 30000 });

// Attach token from localStorage on every request
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('lr_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// On 401: clear token but DO NOT redirect if we're on /auth/me (initial load check)
// Redirect to /login only for other protected endpoint failures
api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      const url = err.config?.url || '';
      localStorage.removeItem('lr_token');
      // Don't redirect to /login if this was the initial /auth/me check
      // AuthContext handles that case by setting user=null and loading=false
      if (!url.includes('/auth/me')) {
        //window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;